// import { gsap } from "gsap"
// import { ScrollTrigger } from "gsap/ScrollTrigger"
import A11yDialog from "a11y-dialog";
// gsap.registerPlugin(ScrollTrigger);
// gsap.config({nullTargetWarn:false});
export default {

  init() {

    // $(document).ready(function(){
    //   var dialogEl = document.getElementById('loginModal');
    //   var dialog = new A11yDialog(dialogEl);

    //   dialog.on('show', function (dialogEl, event) {
    //     console.log(dialogEl);
    //     console.log(event);
    //   });
    // });

    $('.smooth, .smooth a').click(function() {
      if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
        $('.top-bar').removeClass('open');
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html,body').animate({scrollTop: target.offset().top}, 1000); // Set scroll speed here
          return false;
        }
      }
    });

    if ($('.expanding-image-list').length !== -1) {
      var eil = false;
      $(document).on('mouseenter', '.expanding-image-list > .columns:not(.expanded)', function(e) {
        if (eil == false) {
          eil = true;
          window.setTimeout(function () { eil = false }, 400);
          $(this).parent().find('.expanded').removeClass('expanded');
          $(this).addClass('expanded');
        }
      });
    }

    $('.no-link a').on('click', function(event) {
      event.preventDefault();
    });

    // Nav/Hamburger

    $('.hamburger').on('click', function() {
      $(this).toggleClass('is-active');
      $('.top-bar').toggleClass('open');
      $('html').toggleClass('overflow');
    });

    $('.bank-wrap').on('click', function() {
      $(this).next().children('.link-bank').toggleClass('show');
    });

    $('.has-children a').on('click', function() {
      $(this).parent().children('.mega-menu').toggleClass('show');
      $(this).parent().siblings().children('.mega-menu').removeClass('show');
    });

    let gb = document.querySelectorAll('.sub-go-back')

    $(gb).on('click', function() {
      $('.mega-menu').removeClass('show');
    });

    // END Nav/Hamburger

    $('.tabs-title .txt-link').on('click', function() {
      window.location.href = $(this).attr('href');
    });

    $('.mq-slide').slick({
      arrows: false,
      dots: false,
    });

    $('.logo-slider-condensed').slick({
      dots: false,
      arrows: false,
      slidesToShow: 6,
      slidesToScroll: 3,
      autoplay: true,
      responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      ],
    });

    $('.logo-slider-full').slick({
      prevArrow: '<button type="submit" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 108 108"><circle cx="54" cy="54" r="53" fill="none" stroke="#6c6c6c" stroke-width="2"/><path d="m27.71,53.29c-.39.39-.39,1.02,0,1.41l6.36,6.36c.39.39,1.02.39,1.41,0,.39-.39.39-1.02,0-1.41l-5.66-5.66,5.66-5.66c.39-.39.39-1.02,0-1.41-.39-.39-1.02-.39-1.41,0l-6.36,6.36Zm51.87-.29H28.42v2h51.16v-2Z" fill="#6c6c6c"/></svg></button>',
      nextArrow: '<button type="submit" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 108 108"><circle cx="54" cy="54" r="53" fill="none" stroke="#6c6c6c" stroke-width="2"/><path d="m79.29,54.71c.39-.39.39-1.02,0-1.41l-6.36-6.36c-.39-.39-1.02-.39-1.41,0-.39.39-.39,1.02,0,1.41l5.66,5.66-5.66,5.66c-.39.39-.39,1.02,0,1.41.39.39,1.02.39,1.41,0l6.36-6.36Zm-51.87.29h51.16v-2H27.42v2Z" fill="#6c6c6c"/></svg></button>',
      dots: false,
      arrows: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      ],
    });

    $('.logo-slider').slick({
      dots: false,
      arrows: true,
      prevArrow: '<button type="submit" class="slick-prev"><i class="far fa-arrow-left"></i></button>',
      nextArrow: '<button type="submit" class="slick-next"><i class="far fa-arrow-right"></i></button',
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          arrows: true,
          dots: false,
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          arrows: false,
          dots: true,
        },
      },
      ],
    });

    $('.sm-list').slick({
      arrows: false,
      dots: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: false,
      responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
      ],
    });

    // Pinned Marquee
    let pinpanelsIndex = 0
    const pinpanels = Array.from(document.querySelectorAll('.panels__item'))
    if (pinpanels.length) {
      let thepanels = gsap.timeline({
        scrollTrigger: {
         trigger: '.pin-container',
         pin: true,
         scrub: true,
         pinSpacing: true,
         start: "top 147px",
         end: function () {
          return '+=' + window.innerHeight * pinpanels.length
        },
      },
    })
      thepanels.to(document.querySelector('.panels__item-a .panels__item-content h2'), {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'})
      .to(document.querySelectorAll('.panels__item-a .panels__item-content p'), {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'})
      .to(document.querySelector('.panels__item-a .panels__item-content h2'), {y: -50, opacity: 0, duration: 1.5, ease: 'power4.out'})
      .to(document.querySelectorAll('.panels__item-a .panels__item-content p'), {y: -50, opacity: 0, duration: 1.5, ease: 'power4.out'})
      .to(document.querySelector('.panels__item-a .panels__item-bg'), {opacity: 0, duration: 1.5, ease: 'power4.out'})
      .to(document.querySelector('.panels__item-b .panels__item-content h2'), {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'})
      .to(document.querySelectorAll('.panels__item-b .panels__item-content p'), {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'})
      .to(document.querySelector('.panels__item-b .panels__item-content h2'), {y: -50, opacity: 0, duration: 1.5, ease: 'power4.out'})
      .to(document.querySelectorAll('.panels__item-b .panels__item-content p'), {y: -50, opacity: 0, duration: 1.5, ease: 'power4.out'})
      .to(document.querySelector('.panels__item-b .panels__item-bg'), {opacity: 0, duration: 1.5, ease: 'power4.out'})
      .to(document.querySelector('.panels__item-c .panels__item-content h2'), {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'})
      .to(document.querySelectorAll('.panels__item-c .panels__item-content p'), {y: 0, opacity: 1, duration: 1.5, ease: 'power4.out'})

    }

    // Filtering

    // const rating = document.getElementById('rating');
    // const elements = document.querySelectorAll('.tabs-title');
    // rating.addEventListener('change', () => {
    //   let value = rating.value;
    //   elements.forEach((el) => {
    //     if (value === '') {
    //       el.classList.remove('hidden');
    //     } else {
    //       const rating = el.dataset.cats;
    //       if (!rating || rating.includes(value)) {
    //         el.classList.remove("hidden");
    //       } else {
    //         el.classList.add("hidden");
    //       }
    //     }
    //   })
    // })

    // let links = $('.txt-link');
    // links.removeAttr('role');
    // links.removeAttr('aria-controls');
    // links.removeAttr('aria-selected');
    // links.removeAttr('id');
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js